export default __webpack_public_path__ + "static/media/shape7.1e64f088.svg";